import { colors, fontSizes } from "@/app/constants/styles";
import { StyleSheet } from "react-native";

export const buttonStyles = StyleSheet.create({
  buttonContainer: {
    justifyContent: "center",
  },
  radioButtonContainer: {
    width: 40,
    height: 40,
    borderRadius: 100,
    borderColor: colors.maroon,
    borderWidth: 1,
    alignItems: "center",
    justifyContent: "center",
  },
  radioButtonEnabled: {
    width: 30,
    height: 30,
    borderRadius: 100,
    backgroundColor: colors.maroon,
  },
  radioButtonDisabled: {
    width: 30,
    height: 30,
    borderRadius: 100,
  },
});

export const radioButtonStyles = StyleSheet.create({
  container: {
    flex: 1,
    flexDirection: "row",
    backgroundColor: "transparent",
    paddingHorizontal: 10,
    paddingVertical: 20,
  },
  textContainer: {
    marginLeft: 10,
    justifyContent: "center",
  },
  buttonText: {
    fontFamily: "HelveticaNeue-Medium",
    fontSize: fontSizes.x12,
    color: colors.cedar,
  },
  listContainer: {
    flex: 1,
  },
});

export const choiceHeaderStyles = StyleSheet.create({
  container: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    marginLeft: 10,
    marginRight: 20,
    marginBottom: 10,
  },
  headerText: {
    fontFamily: "HelveticaNeue-Medium",
    fontSize: fontSizes.x14,
    color: colors.cedar,
  },
});
